exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n  /* @import '/assets/theme_gold/css/bank-card.css'; */\n.button-wrap button:disabled.button-style-7[data-v-216eefd3]{\n    background: transparent;\n    border: 1px solid #707070;\n}\n.button-wrap button:disabled.button-style-7 > span[data-v-216eefd3]{\n    color: #707070;\n}\n.account_good[data-v-216eefd3] {\n  color: rgb(27, 185, 27);\n  font-size: 12px;\n  line-height: 1;\n  margin-left: auto;\n  margin-top: 5px;\n}\n.form-input.form-input-error-1 input[data-v-216eefd3]:not(.inp-left) {\n  border: 1px solid #FF0000;\n}\n", ""]);

// exports
